/**
 * ReferenceReviewEntry — client-facing surface for a released References letter (docs/REFERENCES.md).
 * View/download only, no signing or response of any kind — mirrors MeetingMinutesEntry.jsx's
 * plain-PDF-book treatment exactly, plus the same open/download engagement ping proposals use
 * (notifyReferenceViewed/Downloaded, same #aj_biz-dev channel, api/journey-proposal-viewed.js's
 * generalized docKind:'reference' branch) — for a reference letter, opening/downloading IS the
 * entire engagement signal, since there's no later "signed" event to also watch for.
 *
 * entry.data: { referenceId, title, pdfUrl, intro }
 */

import { useState } from 'react'
import { J } from '../journeyUI.jsx'
import Markdown from '../../components/Markdown.jsx'
import JourneyBook from './JourneyBook.jsx'
import PdfFlipViewer from '../../components/PdfFlipViewer.jsx'
import { notifyReferenceViewed, notifyReferenceDownloaded } from '../../services/journey.js'

export default function ReferenceReviewEntry({ entry, token, previewMode }) {
  const [open, setOpen] = useState(false)
  const d = entry.data || {}
  const title = d.title || entry.title || 'Client References'

  return (
    <div>
      <div style={{ textAlign: 'center', paddingTop: 10 }}>
        <div style={{ ...J.eyebrow, marginBottom: 18 }}>References</div>
        <h2 style={{ ...J.title, maxWidth: 440, margin: '0 auto' }}>{title}</h2>
        <div style={{ width: 36, height: 1, background: 'rgba(7,39,45,0.24)', margin: '26px auto 30px' }} />
      </div>
      {d.intro && (
        <div style={{ ...J.body, maxWidth: 480, margin: '0 auto 26px' }}>
          <Markdown text={d.intro} />
        </div>
      )}
      {d.pdfUrl ? (
        <>
          {/* downloadUrl is intentionally NOT passed to JourneyBook — its built-in download link
              carries no onClick hook, and a downloaded reference letter needs the same tracked
              ping as opening it (mirrors ProposalReviewEntry.jsx's own tracked-download anchor). */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px 0 6px' }}>
            <JourneyBook
              label="References" aspect={8.5 / 11}
              onOpen={() => { setOpen(true); if (!previewMode) notifyReferenceViewed(token) }}
            />
            <a
              href={d.pdfUrl} target="_blank" rel="noopener noreferrer"
              onClick={() => { if (!previewMode) notifyReferenceDownloaded(token) }}
              style={{ ...J.textLink, marginTop: 18 }}
            >
              Download PDF
            </a>
          </div>
          {open && <PdfFlipViewer pdfUrl={d.pdfUrl} title={title} onClose={() => setOpen(false)} />}
        </>
      ) : (
        <div style={{ ...J.body, fontStyle: 'italic', color: '#8ba6b1', textAlign: 'center', padding: '18px 0 8px' }}>
          This document isn't available yet.
        </div>
      )}
    </div>
  )
}
